export const DIMENSIONS = {
  DEFAULT: '1640px',
  MOBILE: '425px',
  TABLET: '768px',
  LAPTOP: '1024px',
};
